/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import type { Borders } from '../types';

// borderColor is defaulted to the light theme values.
// Dark theme overrides the border colors.
const borders: Borders = {
  border100: {
    borderColor: 'hsla(0, 0%, 0%, 0.04)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 0%, 0.08)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 0%, 0.12)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 0%, 0.16)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 0%, 0.2)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 0%, 0.24)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  radius100: '2px',
  radius200: '4px',
  radius300: '8px',
  radius400: '12px',
  radius500: '16px',
  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: true,
  /** Button, ButtonGroup */
  buttonBorderRadiusMini: '4px',
  buttonBorderRadius: '8px',
  /** Checkbox */
  checkboxBorderRadius: '0px',
  /** Input, Select, Textarea */
  inputBorderRadiusMini: '4px',
  inputBorderRadius: '8px',
  /** Popover, Menu, Tooltip */
  popoverBorderRadius: '8px',
  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: '0px',
  /** Tag */
  tagBorderRadius: '24px',
  /** T-shirt size border radius */
  radiusXs: '4px',
  radiusS: '8px',
  radiusM: '12px',
  radiusL: '16px',
  radiusXl: '24px',
  radiusCircular: '999px'
};
export default borders;